export default {
  cropperAspectRatio() {
    let ratio = 270/220

    if (this.croppingModel === 'cover') {
      ratio = 1600/300
    }

    return ratio
  },

  itemFeaturedImage() {
    if (this.place && this.place.featuredImage && !this.place.featuredImage.match(/base64/g)) {
      const baseUrl = process.env.VUE_APP_BASE_URL

      return `${baseUrl}/assets/img/place/${this.place.featuredImage}?${Math.random()}`
    }

    if (this.place && this.place.featuredImage && this.place.featuredImage.match(/base64/g)) {
      return this.place.featuredImage
    }
  },

  itemCover() {
    if (this.place && this.place.cover && !this.place.cover.match(/base64/g)) {
      const baseUrl = process.env.VUE_APP_BASE_URL

      return `${baseUrl}/assets/img/place/${this.place.cover}?${Math.random()}`
    }

    if (this.place && this.place.cover && this.place.cover.match(/base64/g)) {
      return this.place.cover
    }
  },
}
